import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import {checkHttpStatus, get} from "../../utils/RestUtilsWithAxios";
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import {GET_ATTORNEYS,GET_KAP_MEMBERS} from "../../constants/uri";
import * as Globals from "../../constants/globals";
import PaySenetleri from './PaySenetleri';
import PayDisi from './PayDisi';
import {alertBox} from "../../components/BoxProvider";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import Dropdown from '../../components/Dropdown';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { useSidebarWidth } from '../../hooks/useSidebarWidth';

const RED = Globals.COLOR_FULL_RED;
const GRAY = Globals.COLOR_DARK_GRAY;
const RED_SOFT = 'rgba(174, 59, 51, 0.06)';
const BORDER = '#e6e6e9';
const INFO_BG = '#eef3fb';
const INFO_ACCENT = '#4b6cb7';
const WARM_BG = '#fbf3ea';

const useStyles = makeStyles(theme => ({
    root: { width: '100%' },
    navButton: {
        maxWidth:'100%', marginLeft: 5, marginRight: 5,
        backgroundColor: Globals.COLOR_TRANSPARENT_RED, borderRadius: 4,
    },
    activeNavButton: {
        maxWidth:'100%', marginLeft: 5, marginRight: 5,
        backgroundColor: RED, borderRadius: 4,
    },
    nav: {
        backgroundColor: "white", marginBottom:16, justifyContent: "space-around",
        height: "unset", padding: 5, borderRadius: 4, paddingLeft: 0, paddingRight: 0,
    },
    navText: { color: "white", fontSize: 14 },
    titleBar: { textAlign: 'center', padding: '28px 24px 8px', position: 'relative' },
    closeBtn: { position: 'absolute', right: 12, top: 12, color: '#9a9a9e' },
    iconBadge: {
        width: 60, height: 60, borderRadius: '50%',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: '#f1f4f7', marginBottom: 10,
    },
    titleText: { margin: 0, color: RED, fontWeight: 700, fontSize: 22, letterSpacing: 0.2 },
    content: { padding: '8px 28px 20px' },
    intro: {
        color: GRAY, fontSize: 13.5, lineHeight: 1.7, textAlign: 'center',
        maxWidth: 460, margin: '0 auto',
    },
    redEmphasis: { color: RED, fontWeight: 700 },
    rule: { height: 1, backgroundColor: BORDER, margin: '22px 0 4px' },
    sectionLabel: {
        fontSize: 13, fontWeight: 700, color: '#2b2b2e',
        marginTop: 20, marginBottom: 8, display: 'block',
    },
    star: { color: RED, fontWeight: 700 },
    instruction: {
        color: RED, fontWeight: 700, fontSize: 13.5, lineHeight: 1.55,
        marginTop: 22, marginBottom: 12,
    },
    optionCard: {
        border: '1px solid ' + BORDER, borderRadius: 10,
        padding: '10px 14px', marginBottom: 10, transition: 'all .15s ease',
        '&:hover': { borderColor: '#d9b7b3', backgroundColor: '#fbf8f8' },
    },
    optionCardActive: {
        border: '1px solid ' + RED, borderRadius: 10,
        padding: '10px 14px', marginBottom: 10, backgroundColor: RED_SOFT,
        boxShadow: '0 1px 4px rgba(174,59,51,0.10)',
    },
    optionLabel: { width: '100%', margin: 0, alignItems: 'flex-start' },
    optionText: { color: GRAY, fontSize: 13.5, lineHeight: 1.45, paddingTop: 8 },
    optionBold: { fontWeight: 700, color: '#2b2b2e' },
    condPanel: { backgroundColor: INFO_BG, borderRadius: 8, padding: 14, marginTop: 4, marginBottom: 6 },
    condHelpRow: {
        display: 'flex', alignItems: 'flex-start', gap: 8,
        color: GRAY, fontSize: 12.5, lineHeight: 1.5, marginBottom: 12,
    },
    condInfoIcon: { color: INFO_ACCENT, fontSize: 20, flexShrink: 0, marginTop: 1 },
    fieldRow: { display: 'flex', gap: 12, flexWrap: 'wrap' },
    field: { flex: 1, minWidth: 220, backgroundColor: 'white' },
    fieldFull: { width: '100%', backgroundColor: 'white' },
    attestCard: {
        border: '1px solid ' + BORDER, borderRadius: 10, padding: '12px 14px',
        marginTop: 20, display: 'flex', alignItems: 'flex-start',
    },
    attestText: { fontSize: 12.5, color: GRAY, lineHeight: 1.55 },
    dialogPaper: { width: 680, maxWidth: '92vw' },
    fieldLabel: {
        display: 'block', fontSize: 12.5, fontWeight: 600,height:30,
        color: '#3a3a3e', lineHeight: 1.35, marginBottom: 6,
    },
    actions: { padding: '14px 24px', borderTop: '1px solid ' + BORDER },
    filledBtn: {
        backgroundColor: RED, color: 'white', borderRadius: 8,
        padding: '8px 26px', fontWeight: 600, boxShadow: 'none',
        '&:hover': { backgroundColor: '#98322b', boxShadow: 'none' },
        '&.Mui-disabled': { backgroundColor: '#dcc3c1', color: 'white' },
    },
    outlinedBtn: {
        color: RED, borderColor: RED, borderRadius: 8,
        padding: '8px 22px', fontWeight: 600,
        '&:hover': { borderColor: '#98322b', backgroundColor: RED_SOFT },
    },
    exampleBox: { backgroundColor: WARM_BG, borderRadius: 10, padding: 16, marginBottom: 14 },
    exampleTitle: { color: RED, fontWeight: 700, fontSize: 13.5, marginBottom: 12 },
    exampleItem: {
        display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10,
        color: GRAY, fontSize: 13.5,
    },
    exampleIcon: { color: RED, fontSize: 20 },
    blueBox: {
        display: 'flex', alignItems: 'flex-start', gap: 10,
        backgroundColor: INFO_BG, borderRadius: 10, padding: 14,
        color: GRAY, fontSize: 12.5, lineHeight: 1.55,
    },
}));

const SCOPE_OPTIONS = [
    { value: 'madde11_self',    bold: 'Madde 11', text: 'İdari sorumluluğu bulunan kişiler tarafından gerçekleştirilen işlemler' },
    { value: 'madde11_related', bold: 'Madde 11', text: 'İdari sorumluluğu bulunan kişilerle yakından ilişkili kişiler tarafından gerçekleştirilen işlemler' },
    { value: 'madde12',         bold: 'Madde 12', text: 'Birlikte hareket ile veya dolaylı olarak veya oy haklarına bağlı olarak gerçekleştirilen işlemler.' },
    { value: 'diger',           bold: 'Diğer',    text: 'Yukarıda belirtilen kapsamlar dışında kalan bildirimler' },
];

// Bildirim kapsamı seçimi ve uyarı onay dialogunu yönetir.
function GeneralContainer(props) {
    const classes = useStyles();
    const [pageValue, setPageValue] = React.useState(0);
    const [attorneys,setAttorneys] = React.useState([]);
    const [myselfId,setMyselfId] = React.useState('');
    const [companies,setCompanies] = React.useState([]);
    const [openInfo,setOpenInfo] = React.useState(true);
    const [selectedCompany, setSelectedCompany] = React.useState('');
    const [scope, setScope] = React.useState('');
    const [role, setRole] = React.useState('');
    const [relatedName, setRelatedName] = React.useState('');
    const [relatedRelation, setRelatedRelation] = React.useState('');
    const [madde12Info, setMadde12Info] = React.useState('');
    const [legalBasis, setLegalBasis] = React.useState('');
    const [declared, setDeclared] = React.useState(false);
    const [openDigerInfo, setOpenDigerInfo] = React.useState(false);
    const [openMadde11Confirm, setOpenMadde11Confirm] = React.useState(false);
    const [madde11Confirmed, setMadde11Confirmed] = React.useState(false);
    const [pendingScope, setPendingScope] = React.useState('');
    const sidebarWidth = useSidebarWidth();

    React.useEffect(()=>{
        get(GET_ATTORNEYS)
            .then(function (response) {
                var setList = [];
                for (var i = 0; i < response.data.length; i++) {
                    if(i===0){ setMyselfId(response.data[i].key); }
                    var newItem = {};
                    newItem.value = response.data[i].key;
                    newItem.label = response.data[i].text;
                    setList.push(newItem);
                }
                setAttorneys(setList);
            })
            .catch(function (error) { checkHttpStatus(error,props.intl); });
        get(GET_KAP_MEMBERS)
            .then(function (response) {
                var setList = [];
                for (var i = 0; i < response.data.length; i++) {
                    var newItem = {};
                    newItem.value = response.data[i].key;
                    newItem.label = response.data[i].text;
                    setList.push(newItem);
                }
                setCompanies(setList);
            })
            .catch(function (error) { checkHttpStatus(error,props.intl); });
    },[]);

    const resetWarningDialog = () => {
        setOpenInfo(true);
        setSelectedCompany('');
        setScope('');
        setRole('');
        setRelatedName('');
        setRelatedRelation('');
        setMadde12Info('');
        setLegalBasis('');
        setDeclared(false);
        setMadde11Confirmed(false);
        setPendingScope('');
        setOpenMadde11Confirm(false);
    };

    const handleScopeChange = (value) => {
        if (value === 'madde11_self' || value === 'madde11_related') {
            setPendingScope(value);
            setMadde11Confirmed(false);  // Dialog her açıldığında checkbox'ı sıfırla
            setOpenMadde11Confirm(true);
        } else {
            setScope(value);
            if (value !== 'madde11_self') setRole('');
            if (value !== 'madde11_related') { setRelatedName(''); setRelatedRelation(''); }
            if (value !== 'madde12') setMadde12Info('');
            if (value !== 'diger') setLegalBasis('');
            if (value === 'diger') setOpenDigerInfo(true);
        }
    };

    // Madde 11 onay dialogunu kapatma ve scope'u temizleme
    const handleMadde11Close = () => {
        setOpenMadde11Confirm(false);
        setMadde11Confirmed(false);  // Checkbox'ı false yap
        setPendingScope('');
        setScope('');
        setRole('');
        setRelatedName('');
        setRelatedRelation('');
    };

    // Madde 11 onay dialogunu onaylama
    const handleMadde11Confirm = () => {
        if (madde11Confirmed) {
            setOpenMadde11Confirm(false);
            setScope(pendingScope);
        }
    };

    const isValid =
        !!selectedCompany &&
        !!scope &&
        declared &&
        (scope !== 'madde11_self'    || role.trim().length > 0) &&
        (scope !== 'madde11_related' || (relatedName.trim().length > 0 && relatedRelation.trim().length > 0)) &&
        (scope !== 'madde12'         || madde12Info.trim().length > 0) &&
        (scope !== 'diger'           || legalBasis.trim().length > 0);

    const handleConfirm = () => { if (isValid) setOpenInfo(false); };

    const bildirimContext = {
        company: selectedCompany,
        scope, role, relatedName, relatedRelation, madde12Info, legalBasis,
    };

    // Seçilen kapsam türüne göre dinamik ek alanları render eder.
    const renderScopeExtra = (value) => {
        if (value === 'madde11_self') {
            return (
                <div className={classes.condPanel}>
                    <TextField
                        className={classes.fieldFull}
                        required
                        size="small"
                        variant="outlined"
                        label="Şirketteki görevinizi belirtiniz"
                        placeholder="Örn: Yönetim Kurulu Üyesi"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        inputProps={{ maxLength: 500 }}
                    />
                </div>
            );
        }
        if (value === 'madde11_related') {
            return (
                <div className={classes.condPanel}>
                    <div className={classes.condHelpRow}>
                        <InfoOutlinedIcon className={classes.condInfoIcon} />
                        <span>
                            Lütfen, yakından ilişkili olduğunuzu beyan ettiğiniz idari sorumluluğu bulunan kişinin
                            ad ve soyadı bilgisi ile aranızdaki ilişkiyi belirtiniz.
                        </span>
                    </div>
                    <div className={classes.fieldRow}>
                        <div className={classes.field} style={{ flex: 2, minWidth: 300 }}>
                            <TextField
                                fullWidth
                                required
                                size="small"
                                variant="outlined"
                                label="İdari Sorumluluğu Bulunan Kişinin Adı Soyadı"
                                placeholder=""
                                value={relatedName}
                                onChange={(e) => setRelatedName(e.target.value)}
                                className={classes.fieldFull}
                                inputProps={{ maxLength: 500 }}
                            />
                        </div>
                        <div className={classes.field} style={{ flex: 1, minWidth: 180 }}>
                            <TextField
                                fullWidth
                                required
                                size="small"
                                variant="outlined"
                                label="İlişki Derecesi"
                                placeholder="Örn: Eşi, Kardeşi, Çocuğu vb."
                                value={relatedRelation}
                                onChange={(e) => setRelatedRelation(e.target.value)}
                                className={classes.fieldFull}
                                inputProps={{ maxLength: 500 }}
                            />
                        </div>
                    </div>
                </div>
            );
        }
        if (value === 'madde12') {
            return (
                <div className={classes.condPanel}>
                    <TextField
                        className={classes.fieldFull}
                        required
                        size="small"
                        variant="outlined"
                        label="Birlikte hareket ile veya dolaylı olarak veya oy hakları hakkında bilgi veriniz."
                        value={madde12Info}
                        onChange={(e) => setMadde12Info(e.target.value)}
                        multiline
                        rows={3}
                        inputProps={{ maxLength: 500 }}
                    />
                </div>
            );
        }
        if (value === 'diger') {
            return (
                <div className={classes.condPanel}>
                    <TextField
                        className={classes.fieldFull}
                        required
                        size="small"
                        variant="outlined"
                        label="Bildirimin hukuki dayanağına ilişkin açıklamanızı yazınız"
                        value={legalBasis}
                        onChange={(e) => setLegalBasis(e.target.value)}
                        multiline
                        rows={3}
                        inputProps={{ maxLength: 500 }}
                    />
                </div>
            );
        }
        return null;
    };

    return(
        <div className={classes.root}>
            <Dialog
                open={openInfo}
                maxWidth={false}
                scroll="paper"
                disableEnforceFocus
                disableScrollLock
                disableBackdropClick
                style={{ pointerEvents: 'none' }}
                BackdropProps={{
                    style: {
                        pointerEvents: 'auto',
                        top: '65px',
                        left: `${sidebarWidth}px`
                    }
                }}
                PaperProps={{
                    className: classes.dialogPaper,
                    style: { pointerEvents: 'auto' }
                }}
            >
                <DialogTitle disableTypography className={classes.titleBar}>
                    <div className={classes.iconBadge}>
                        <InfoOutlinedIcon style={{ fontSize: 38, color: '#9fb0bd' }} />
                    </div>
                    <h2 className={classes.titleText}>Uyarı!</h2>
                </DialogTitle>

                <DialogContent dividers className={classes.content}>
                    <div
                        style={{
                            padding: "20px 24px",
                            border: "1px solid #d9e2ec",
                            borderRadius: "10px",
                            background: "#f8fafc",
                            color: "#334155",
                            fontSize: "14px",
                            lineHeight: "1.7",
                        }}
                    >
                        <p style={{ margin: "0 0 12px" }}>
                            Bu alan yalnızca,{" "}
                            <strong style={{ color: "#0f172a", fontWeight: 600 }}>
                                Sermaye Piyasası Kurulu’nun II-15.1 sayılı Özel Durumlar Tebliği’nin
                                11, 12 ve 22. maddeleri
                            </strong>{" "}
                            kapsamındaki işlemlerin Merkezi Kayıt Kuruluşu A.Ş.’ye bildirilmesi
                            amacıyla kullanılmalıdır.
                        </p>
                        <p style={{ margin: "0 0 16px" }}>
                            Mevzuat kapsamı dışında kalan, kamuya açıklanma yükümlülüğü bulunmayan
                            veya test amacı taşıyan bildirimler bu form üzerinden{" "}
                            <strong style={{ color: "#0f172a", fontWeight: 600 }}>
                                kesinlikle gönderilmemelidir.
                            </strong>
                        </p>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "10px",
                                padding: "12px 16px",
                                borderLeft: "4px solid #d97706",
                                borderRadius: "6px",
                                background: "#fffbeb",
                                color: "#92400e",
                            }}
                        >
                            <span style={{ flexShrink: 0, fontWeight: 700, textTransform: "uppercase" }}>
                                ⚠️ Uyarı
                            </span>
                            <span>
                                Kapsam dışı bildirimler Sermaye Piyasası Kuruluna raporlanabilir ve
                                ilgili kişiler hakkında idari yaptırım uygulanabilir.
                            </span>
                        </div>
                    </div>

                    <div className={classes.rule} />

                    <span className={classes.sectionLabel}>
                        Bildirime Konu Borsa Şirketi <span className={classes.star}>*</span>
                    </span>
                    <Dropdown
                        required noMargin name="company" id="company" title="Lütfen seçiniz"
                        items={companies} containerSelectedItem={selectedCompany}
                        handleContainerChange={(val) => setSelectedCompany(val)}
                    />

                    <div className={classes.instruction}>
                        Lütfen göndermekte olduğunuz bildirimin, Sermaye Piyasası Kurulu&rsquo;nun II-15.1 sayılı
                        Özel Durumlar Tebliği kapsamında hangi bildirim yükümlülüğüne dayandığını seçiniz.
                    </div>

                    <RadioGroup value={scope} onChange={(e) => handleScopeChange(e.target.value)}>
                        {SCOPE_OPTIONS.map((opt) => {
                            const selected = scope === opt.value;
                            return (
                                <div key={opt.value} className={selected ? classes.optionCardActive : classes.optionCard}>
                                    <FormControlLabel
                                        className={classes.optionLabel}
                                        value={opt.value}
                                        control={<Radio style={{ color: RED }} />}
                                        label={
                                            <span className={classes.optionText}>
                                                <span className={classes.optionBold}>{opt.bold} </span>
                                                &ndash; {opt.text}
                                            </span>
                                        }
                                    />
                                    {selected && renderScopeExtra(opt.value)}
                                </div>
                            );
                        })}
                    </RadioGroup>

                    <div className={classes.attestCard}>
                        <Checkbox
                            checked={declared}
                            onChange={(e) => setDeclared(e.target.checked)}
                            style={{ color: RED, padding: 0, marginRight: 10, marginTop: 2 }}
                        />
                        <span className={classes.attestText}>
                            <span className={classes.star}>* </span>
                            Göndermekte olduğum bildirimin, yukarıda seçtiğim kapsam doğrultusunda Sermaye
                            Piyasası Kurulu&rsquo;nun II-15.1 sayılı Özel Durumlar Tebliği hükümleri uyarınca
                            bildirim yükümlülüğüne tabi olduğunu beyan ederim.
                        </span>
                    </div>
                </DialogContent>

                <DialogActions className={classes.actions}>
                    <Button className={classes.filledBtn} variant="contained" onClick={handleConfirm} disabled={!isValid}>
                        {props.intl.formatMessage({id: "ALERTBOX.BTN.OK.TITLE"})}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Madde 11 Onay Dialogu */}
            <Dialog
                open={openMadde11Confirm}
                maxWidth={false}
                scroll="paper"
                disableEnforceFocus
                disableScrollLock
                disableBackdropClick
                style={{ pointerEvents: 'none' }}
                BackdropProps={{
                    style: {
                        pointerEvents: 'auto',
                        top: '65px',
                        left: `${sidebarWidth}px`
                    }
                }}
                PaperProps={{
                    className: classes.dialogPaper,
                    style: { pointerEvents: 'auto' }
                }}
            >
                <DialogTitle disableTypography className={classes.titleBar}>
                    <IconButton className={classes.closeBtn} size="small" onClick={handleMadde11Close} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <div className={classes.iconBadge}>
                        <InfoOutlinedIcon style={{ fontSize: 38, color: '#9fb0bd' }} />
                    </div>
                    <h2 className={classes.titleText}>Beyan Gerekliliği</h2>
                </DialogTitle>

                <DialogContent dividers className={classes.content}>
                    <div className={classes.attestCard}>
                        <Checkbox
                            checked={madde11Confirmed}
                            onChange={(e) => setMadde11Confirmed(e.target.checked)}
                            style={{ color: RED, padding: 0, marginRight: 10, marginTop: 2 }}
                        />
                        <span className={classes.attestText}>
                            <span className={classes.star}>* </span>
                            &ldquo;Gerçekleştirdiğim işlemlerin toplam tutarının 15.000.000 TL&rsquo;yi aştığını ve bu
                            nedenle Özel Durumlar Tebliği&rsquo;nin (II-15.1) 11&rsquo;inci maddesi kapsamında KAP&rsquo;ta
                            açıklama yükümlülüğüm bulunduğunu beyan ederim.&rdquo;
                        </span>
                    </div>
                </DialogContent>

                <DialogActions className={classes.actions}>
                    <Button className={classes.filledBtn} variant="contained" onClick={handleMadde11Confirm} disabled={!madde11Confirmed}>
                        {props.intl.formatMessage({id: "ALERTBOX.BTN.OK.TITLE"})}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openDigerInfo} maxWidth={false} scroll="paper" PaperProps={{ className: classes.dialogPaper }}>
                <DialogTitle disableTypography className={classes.titleBar}>
                    <IconButton className={classes.closeBtn} size="small" onClick={() => setOpenDigerInfo(false)} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <div className={classes.iconBadge} style={{ backgroundColor: '#fbf1e8' }}>
                        <ErrorOutlineIcon style={{ fontSize: 38, color: '#e0913b' }} />
                    </div>
                    <h2 className={classes.titleText}>Bilgilendirme</h2>
                </DialogTitle>

                <DialogContent dividers className={classes.content}>
                    <div className={classes.intro} style={{ marginBottom: 18 }}>
                        &ldquo;Diğer&rdquo; seçeneğini işaretlediğiniz için aşağıda örnekleri verilen bildirimleri
                        yapabileceğinizi hatırlatmak isteriz.
                    </div>

                    <div className={classes.exampleBox}>
                        <div className={classes.exampleTitle}>
                            &ldquo;Diğer&rdquo; seçeneği kapsamında örnek olarak yapılabilecek bildirimler:
                        </div>
                        {[
                            'Pay Satış Bilgi Formu başvuruları',
                            'Birlikte hareket edilmesine ilişkin bildirimler',
                            'İçsel bilgilere erişimi olan kişilere ilişkin bildirimler (Madde 7)',
                            'Mevzuat kapsamında yer alan diğer bildirimler',
                        ].map((t, i) => (
                            <div className={classes.exampleItem} key={i}>
                                <CheckCircleOutlineIcon className={classes.exampleIcon} />
                                <span>{t}</span>
                            </div>
                        ))}
                    </div>

                    <div className={classes.blueBox}>
                        <InfoOutlinedIcon className={classes.condInfoIcon} />
                        <span>
                            Bu seçenek, II-15.1 sayılı Özel Durumlar Tebliği&rsquo;nin 11. ve 12. maddeleri dışında kalan
                            ancak II-15.1 sayılı Özel Durumlar Tebliği kapsamında bildirimi gereken işlemler için
                            kullanılmalıdır.
                        </span>
                    </div>
                </DialogContent>

                <DialogActions className={classes.actions} style={{ justifyContent: 'space-between' }}>
                    <Button
                        className={classes.outlinedBtn} variant="outlined"
                        onClick={() => { setOpenDigerInfo(false); setScope(''); setLegalBasis(''); }}
                    >
                        Geri Dön
                    </Button>
                    <Button className={classes.filledBtn} variant="contained" onClick={() => setOpenDigerInfo(false)}>
                        {props.intl.formatMessage({id: "ALERTBOX.BTN.OK.TITLE"})}
                    </Button>
                </DialogActions>
            </Dialog>

            <BottomNavigation
                value={pageValue}
                onChange={(event, newValue) => { setPageValue(newValue); }}
                showLabels classes={{root: classes.nav}}
            >
                <BottomNavigationAction
                    label={<span className={classes.navText}>Pay Senetlerine İlişkin Bildirimler</span>}
                    classes={{root: pageValue === 0 ? classes.activeNavButton : classes.navButton}}  />
                <BottomNavigationAction
                    label={<span className={classes.navText}>Pay Dışında Sermaye Piyasası Araçlarına İlişkin Bildirimler</span>}
                    classes={{root: pageValue === 1 ? classes.activeNavButton : classes.navButton}} />
            </BottomNavigation>
            {
                pageValue === 0 ?
                    <PaySenetleri attorneys={attorneys} myselfId={myselfId} companies={companies} bildirimContext={bildirimContext} resetWarningDialog={resetWarningDialog}/>
                :
                    <PayDisi attorneys={attorneys} myselfId={myselfId} companies={companies} bildirimContext={bildirimContext} resetWarningDialog={resetWarningDialog}/>
            }
        </div>
    )
}

export default injectIntl(
    connect(
        null,
    )(GeneralContainer)
);